var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.549805 3.21655H1.88314H12.5498",
    stroke: "#D93E3E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2161 3.21672V12.55C11.2161 12.9037 11.0757 13.2428 10.8256 13.4929C10.5756 13.7429 10.2364 13.8834 9.88281 13.8834H3.21615C2.86252 13.8834 2.52339 13.7429 2.27334 13.4929C2.02329 13.2428 1.88281 12.9037 1.88281 12.55V3.21672M3.88281 3.21672V1.88338C3.88281 1.52976 4.02329 1.19062 4.27334 0.940573C4.52339 0.690525 4.86252 0.550049 5.21615 0.550049H7.88281C8.23643 0.550049 8.57557 0.690525 8.82562 0.940573C9.07567 1.19062 9.21615 1.52976 9.21615 1.88338V3.21672",
    stroke: "#D93E3E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2168 6.5498V10.5498",
    stroke: "#D93E3E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88281 6.5498V10.5498",
    stroke: "#D93E3E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteClass);
export default __webpack_public_path__ + "static/media/delete-class.60ca0763e02202f971a69576a11d94ec.svg";
export { ForwardRef as ReactComponent };